module.exports = function(bh) {
  bh.match('product-panel__stock-price', function(ctx, json) {
    let price = Math.floor(Math.random()*10000);
    ctx.content([
      price+' ₽',
      {tag: 'span', content: ' цена в аптеке'},
    ]);
  });
};
